import { EventEmitter } from '@angular/core';
import { InfluencerGroup } from '../../../../models/influencer-group';
import { GroupService } from '../../../services/group-details/group.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../services/user.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { InfluencerGroupStatus } from '../../../app.constants';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { ActionDetails, ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../../services/event-tracker/event-tracker.service';
import { CacheService } from '../../../services/cache/cache.service';
import { Router } from '@angular/router';
import { NewGroupSettingsComponent } from '../new-group-settings/new-group-settings.component';
import { ProjectService } from '../../../services/project/project.service';
var GroupDetailsBreadcumbComponent = /** @class */ (function () {
    function GroupDetailsBreadcumbComponent(groupService, userService, cacheService, route, translate, modalService, validationHandlerService, placeholderVisibilityService, eventTracker, projectService) {
        this.groupService = groupService;
        this.userService = userService;
        this.cacheService = cacheService;
        this.route = route;
        this.translate = translate;
        this.modalService = modalService;
        this.validationHandlerService = validationHandlerService;
        this.placeholderVisibilityService = placeholderVisibilityService;
        this.eventTracker = eventTracker;
        this.projectService = projectService;
        this.influencerGroup = new InfluencerGroup();
        this.searchTextEvent = new EventEmitter();
        this.updateGroupEvent = new EventEmitter();
        this.editOrCreateProjectEvent = new EventEmitter();
        this.showGroupSetting = false;
        this.listProjectOfAdvertiser = [];
        this.elementPaths = [];
    }
    GroupDetailsBreadcumbComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.get('group_details.breadcumb_root').subscribe(function (value) {
            _this.elementPaths.push({
                name: value,
                link: '/groups'
            });
        });
        this.elementPaths.push({ name: this.influencerGroup.influencer_group_name,
            link: '/groups/' + this.influencerGroup.influencer_group_id });
        this.getAllProjectOfAdvertiser();
        this.createOrUpdateProjectSubscription = this.projectService.createOrUpdateProjectObserver.subscribe(function (project) {
            if (project && _this.newGroupSetting) {
                _this.newGroupSetting.reloadAndSetSelectedProject(project);
            }
        });
    };
    GroupDetailsBreadcumbComponent.prototype.ngOnDestroy = function () {
        if (this.createOrUpdateProjectSubscription) {
            this.createOrUpdateProjectSubscription.unsubscribe();
        }
    };
    GroupDetailsBreadcumbComponent.prototype.getAllProjectOfAdvertiser = function () {
        var _this = this;
        this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
            _this.listProjectOfAdvertiser = res ? res.data : [];
        });
    };
    GroupDetailsBreadcumbComponent.prototype.editInfluencerGroupSetting = function () {
        this.showGroupSetting = this.influencerGroup.status === InfluencerGroupStatus.PENDING ? false : true;
    };
    GroupDetailsBreadcumbComponent.prototype.closeSetting = function () {
        var _this = this;
        this.showGroupSetting = false;
        setTimeout(function () {
            _this.reloadGroupSettingData(_this.influencerGroup.influencer_group_id);
        }, 100);
    };
    GroupDetailsBreadcumbComponent.prototype.reloadGroupSettingData = function (groupId) {
        var _this = this;
        this.groupSetting = null;
        this.groupService.getInfluencerGroup(groupId).subscribe(function (res) {
            _this.groupSetting = res;
        });
    };
    GroupDetailsBreadcumbComponent.prototype.onSearchText = function (e) {
        this.searchTextEvent.emit(e);
    };
    GroupDetailsBreadcumbComponent.prototype.closeWarningUpdateGroupPopup = function () {
        this.modalService.close();
    };
    GroupDetailsBreadcumbComponent.prototype.getFirstLink = function () {
        return this.elementPaths.length > 0 ? this.elementPaths[0].link : '';
    };
    GroupDetailsBreadcumbComponent.prototype.shouldShowArrowRight = function (index) {
        return index < (this.elementPaths.length - 1);
    };
    GroupDetailsBreadcumbComponent.prototype.shouldShowEditIcon = function (index) {
        return index === (this.elementPaths.length - 1) && !this.showGroupSetting;
    };
    GroupDetailsBreadcumbComponent.prototype.shouldShowCloseSettingIcon = function (index) {
        return index === (this.elementPaths.length - 1) && this.showGroupSetting;
    };
    Object.defineProperty(GroupDetailsBreadcumbComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GroupDetailsBreadcumbComponent.prototype, "openNewGroupSetting", {
        get: function () {
            return this.groupSetting;
        },
        enumerable: true,
        configurable: true
    });
    GroupDetailsBreadcumbComponent.prototype.back = function () {
        this.cacheService.disableCacheRemoving(this.listGroupCachingKey(this.influencerGroup.influencer_group_id));
        this.route.onSameUrlNavigation = GroupDetailsBreadcumbComponent.ONRELOAD;
        this.route.navigate(['groups'], {
            queryParams: {
                activeAccount: this.activeAccount
            }
        });
    };
    GroupDetailsBreadcumbComponent.prototype.listGroupCachingKey = function (influencerGroupId) {
        return [
            "influencer_list_of_group_" + influencerGroupId,
            "influencer_group_" + influencerGroupId,
            "influencer_list_of_group_" + influencerGroupId + "_scrollId",
        ];
    };
    Object.defineProperty(GroupDetailsBreadcumbComponent.prototype, "invalidActionData", {
        get: function () {
            return {
                action: UserActionType.ACTION,
                item: Page.GROUP,
                target: {
                    type: TargetType.INFLUENCER_GROUP
                },
                params: {
                    action: UserActionType.UPDATE,
                    source: ActionSource.PAGE,
                    actionDetails: ActionDetails.UPDATE_CONFIG,
                },
                activePage: {
                    type: ActivePages.GROUP_DETAILS,
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    GroupDetailsBreadcumbComponent.prototype.updateGroup = function (evt) {
        this.updateGroupEvent.emit(this.influencerGroup);
    };
    GroupDetailsBreadcumbComponent.prototype.editOrCreateProject = function (project) {
        this.editOrCreateProjectEvent.emit(project);
    };
    GroupDetailsBreadcumbComponent.prototype.beforeSubmitGroupSetting = function () {
        this.showGroupSetting = false;
    };
    GroupDetailsBreadcumbComponent.prototype.afterSubmitGroupSetting = function (evt) {
        if (evt.isError) {
            this.showGroupSetting = true;
            this.modalService.open(this.saveGroupSettingError, null, true);
        }
        else {
            this.reloadGroupSettingData(this.influencerGroup.influencer_group_id);
        }
    };
    GroupDetailsBreadcumbComponent.ONRELOAD = 'reload';
    return GroupDetailsBreadcumbComponent;
}());
export { GroupDetailsBreadcumbComponent };



// WEBPACK FOOTER //
// ./src/app/main/group-details/group-details-breadcumb/group-details-breadcumb.component.ts.pre-build-optimizer.js